import styled from 'styled-components'

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: #ffffff;
  font-family: 'Montserrat', sans-serif;
`

export const HeroSection = styled.section`
  background: linear-gradient(135deg, #0a1e3d 0%, #1a3a5c 100%);
  padding: 100px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 600px;

  @media (max-width: 768px) {
    padding: 60px 24px;
    min-height: 500px;
  }
`

export const HeroContent = styled.div`
  max-width: 720px;
  width: 100%;
  text-align: center;
`

export const HeroText = styled.div`
  margin-bottom: 48px;
`

export const HeroTitle = styled.h1`
  font-size: 56px;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 16px 0;
  line-height: 1.2;
  letter-spacing: -1px;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`

export const HeroSubtitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: #ff8c42;
  margin: 0 0 16px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`

export const HeroDescription = styled.p`
  font-size: 16px;
  color: #e0e8f5;
  margin: 0;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`

export const LoginBtn = styled.button`
  background: #ff8c42;
  color: #ffffff;
  border: none;
  padding: 16px 40px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);

  &:hover {
    background: #ff7a22;
    box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 14px 32px;
    font-size: 14px;
  }
`

export const FeaturesSection = styled.section`
  padding: 80px 24px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 60px 24px;
  }
`

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

export const FeatureCard = styled.div`
  background: #f8fafb;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 40px 24px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff8c42;
    box-shadow: 0 8px 24px rgba(10, 30, 61, 0.1);
    transform: translateY(-4px);
  }
`

export const FeatureIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  line-height: 1;
`

export const FeatureTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0 0 12px 0;
`

export const FeatureText = styled.p`
  font-size: 14px;
  color: #5a6b7a;
  margin: 0;
  line-height: 1.6;
`

export const FooterSection = styled.footer`
  background: #0a1e3d;
  color: #e0e8f5;
  text-align: center;
  padding: 32px 24px;
  font-size: 14px;
  border-top: 2px solid #ff8c42;

  p {
    margin: 0;
    font-family: 'Montserrat', sans-serif;
  }
`
